import { render, staticRenderFns } from "./checkBoxInput.vue?vue&type=template&id=38e699dd&scoped=true&"
import script from "./checkBoxInput.vue?vue&type=script&lang=js&"
export * from "./checkBoxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e699dd",
  null
  
)

export default component.exports